import type { SettlementDetail } from 'common/src/api/excel-process';
import type { ShipmentBox } from 'common/src/utils/types';

export const mapShipmentToSettlementDetail = (
  box: ShipmentBox,
  exporterName: string
): SettlementDetail => {
  const kilos = (box.quantity || 0) * (box.box_weight || 0);
  return {
    exportadora: exporterName,
    referencia: box.reference_number || '',
    codigo_embalaje: box.box_type || '',
    cliente: box.receiver || '',
    exporter_receiver_id: box.exporter_receiver_id ?? null,
    nave: box.ship_name || '',
    mercado: '',
    categoria: box.category || '',
    nro_contenedor: box.container_number || '',
    fecha_venta: box.ship_eta ? box.ship_eta.split('T')[0] : '',
    color: box.color?.toUpperCase() || '',
    embalaje_etiqueta: box.box_label || '',
    formato: box.box_format || '',
    pallet_identificador: box.pallet || '',
    variedad: box.labeled_variety ?? box.variety ?? '',
    peso_bulto: box.box_weight || 0,
    calibre_color: box.caliber?.toUpperCase() || '',
    bultos_cargados: box.quantity || 0,
    precio_por_caja: 0,
    kilos,
    moneda: '',
    clausula: 'FOB',
    ingreso_moneda_origen: 0,
    tax_moneda_origen: 0,
    comision_moneda_origen: 0,
    costos_logisticos_moneda_origen: 0,
    repacking_costs_moneda_origen: 0,
    flete_usd: 0,
    tipo_cambio: 0,
  };
};
